// Build-time density switch for the agent CRM page (`/crm`).
//
// One client's process configures 15-20 CRM fields; at the default density the
// agent has to scroll the CRM card to fill them in during wrap-up, which costs
// handle time. Setting REACT_APP_CRM_COMPACT_VIEW='true' tightens the layout for
// that deployment only — anything else (unset, 'false', empty) leaves the page
// exactly as it was. The styling half lives in
// src/assets/scss/layout/_crm-compact.scss, scoped under `.crm-compact`.
//
// CRA inlines process.env at build time: the dev server has to be restarted
// after changing this, a hot reload will not pick it up.
export const IS_CRM_COMPACT = process.env.REACT_APP_CRM_COMPACT_VIEW === 'true';

// CRM/disposition fields render 3-up at every breakpoint by default. Compact goes
// 4-up on wide screens — 20 fields drop from 7 rows to 5 — but steps down on
// narrow ones so labels aren't crushed. Spread onto <Row>, which turns these into
// Bootstrap's row-cols-* classes.
export const CRM_FIELD_ROW_COLS = IS_CRM_COMPACT ? { xs: 1, md: 2, xl: 4 } : { xs: '3' };

// The free-text comment box on the Information panel. One row in compact — it still
// scrolls and drag-resizes, and three rows of empty box is a field row's worth of height.
export const CRM_COMMENT_ROWS = IS_CRM_COMPACT ? 1 : 3;
